import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FuseConfirmDialogComponent } from 'app/projects/fuse/src/lib/components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MaxBrainConfirmDialogComponent extends FuseConfirmDialogComponent {
    public confirmTitle: string;
    public entitiesLength: number;
    public confirmButtonColor = 'accent';
    public hideActionButton: boolean = false;
    public hideAdditionalActionButton: boolean = true;
    public actionButtonText: string = 'GENERAL.BUTTON.CONFIRM';
    public additionalActionButtonText: string = 'GENERAL.BUTTON.DISCARD';

    /**
     * When set, the confirm action stays disabled until the user types this keyword.
     */
    public typedConfirmationKeyword: string | null = null;
    public typedConfirmationLabel: string = 'USER.DIALOG.DELETE.TYPE_TO_CONFIRM';
    public typedConfirmationValue: string = '';
    public isTypedConfirmationValid: boolean = false;

    constructor(dialogRef: MatDialogRef<MaxBrainConfirmDialogComponent>) {
        super(dialogRef);
    }

    onTypedConfirmationChange(value: string): void {
        this.typedConfirmationValue = value;
        this.isTypedConfirmationValid =
            !!this.typedConfirmationKeyword && value.trim().toLowerCase() === this.typedConfirmationKeyword.trim().toLowerCase();
    }

    confirm(): void {
        if (this.typedConfirmationKeyword && !this.isTypedConfirmationValid) {
            return;
        }

        this.dialogRef.close(true);
    }
}
